import { gql, TypedDocumentNode } from '@apollo/client';
import { LookQuery, LookQueryVariables } from '../../generated/types';
import { useSkippableQuery } from '../../hooks/useSkippableQuery';
import { useCountry } from '../CountrySelector';
import { VARIANT_CELL_FRAGMENT } from '../Grid';

export const LOOK_QUERY: TypedDocumentNode<LookQuery, LookQueryVariables> = gql`
  query LookQuery($id: String!, $countryCode: String) {
    look(id: $id) {
      id
      name
      position
      nextLookId: next_look_id
      previousLookId: previous_look_id
      trunkshowName: trunkshow_name
      trunkshow {
        lookIds: look_ids
      }
      variants {
        edges {
          node {
            ...VariantCellFragment
          }
        }
      }
    }
  }
  ${VARIANT_CELL_FRAGMENT}
`;

export const useLook = (lookId: string | string[] | undefined) => {
  const {
    country: { alpha2Code: countryCode }
  } = useCountry();

  const id = lookId && typeof lookId !== 'string' ? lookId[0] : lookId;

  const { data, loading, error } = useSkippableQuery(LOOK_QUERY, {
    variables: { id: id || '', countryCode },
    skip: id === undefined
  });

  // Some looks are disabled so the look position does not reflect that
  const actualPositionInActiveLooks =
    Number(data && data?.look?.trunkshow?.lookIds.findIndex(look => look === Number(id))) + 1;

  return {
    variants: data?.look?.variants?.edges?.map(variant => variant?.node) || [],
    numberOfVariants: data?.look?.variants?.edges?.length,
    numberOfLooks: data?.look?.trunkshow?.lookIds?.length,
    trunkshowName: data?.look?.trunkshowName,
    nextLookId: data?.look?.nextLookId,
    prevLookId: data?.look?.previousLookId,
    position: actualPositionInActiveLooks,
    loading,
    error
  };
};
